import React from 'react';
import styles from '@/views/Layout/internal/Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <p className='text-center text-md-left text-muted'>
        Copyright © 2012 - {currentYear}
        <a
          href='http://www.abagile.com'
          target='_blank'
          rel='noopener noreferrer'
        >
          ABAgile
        </a>
        . All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
